export default "__VITE_ASSET__23336446__"